export const fr = {
    common: {
        cancel: 'Annuler',
        save: 'Enregistrer',
        delete: 'Supprimer',
        edit: 'Modifier',
        create: 'Créer',
        loading: 'Chargement…',
        copy: 'Copier',
        ok: 'OK',
        close: 'Fermer',
        or: 'ou',
        creating: 'Création...',
        unknownError: 'Erreur inconnue',
        none: 'Aucun',
        color: 'Couleur',
        visible: 'Visible',
        locked: 'Verrouillé',
        hide: 'Masquer',
        show: 'Afficher',
        lock: 'Verrouiller',
        unlock: 'Déverrouiller',
        update: 'Mettre à jour',
    },
    language: {
        label: 'Langue',
    },
    auth: {
        welcome: 'Bienvenue sur tween.studio — créez du mouvement, composez des scènes et donnez vie à vos histoires.',
        email: 'E-mail',
        password: 'Mot de passe',
        emailPlaceholder: 'vous@exemple.com',
        name: 'Prénom',
        surname: 'Nom',
        namePlaceholder: 'Ada',
        surnamePlaceholder: 'Lovelace',
        confirmPassword: 'Confirmer le mot de passe',
        termsOfService: "Conditions d'utilisation",
        privacyPolicy: 'Politique de confidentialité',
        and: 'et',
        signInTitle: 'Connexion',
        signInSubtitle: 'Reprenez là où vous vous êtes arrêté.',
        signIn: 'Se connecter',
        signingIn: 'Connexion...',
        noAccount: "Vous n'avez pas de compte ?",
        signUp: "S'inscrire",
        loginFailed: 'Échec de la connexion',
        googleSignInFailed: 'Échec de la connexion Google',
        googleSignInLoadFailed: 'Impossible de charger la connexion Google',
        continueWithFacebook: 'Continuer avec Facebook',
        continueWithInstagram: 'Continuer avec Instagram',
        metaSignInComingSoon: 'La connexion {brand} utilise Meta Login — branchement à venir. Le fournisseur peut être configuré dans l’admin.',
        createAccountTitle: 'Créer un compte',
        createAccountSubtitle: 'Rejoignez tween.studio et commencez à animer.',
        createAccount: 'Créer un compte',
        creatingAccount: 'Création du compte...',
        hasAccount: 'Vous avez déjà un compte ?',
        signInLink: 'Se connecter',
        termsAgreePrefix: 'En créant un compte, vous acceptez nos',
        termsAgreeSuffix: '.',
        passwordMinLength: 'Le mot de passe doit contenir au moins 6 caractères.',
        passwordsDoNotMatch: 'Les mots de passe ne correspondent pas.',
        registrationFailed: "Échec de l'inscription",
    },
    theme: {
        label: 'Thème',
        light: 'Clair',
        dark: 'Sombre',
        system: 'Système',
        switchToLight: 'Passer en mode clair',
        switchToDark: 'Passer en mode sombre',
    },
    connection: {
        Connected: 'Connecté',
        Connecting: 'Connexion',
        Reconnecting: 'Reconnexion',
        Disconnected: 'Déconnecté',
        Error: 'Erreur',
    },
    toolbar: {
        selectMovie: 'Sélectionner un film',
        ai: 'IA',
        notifications: 'Notifications',
        loadingNotifications: 'Chargement des notifications...',
        noNotifications: 'Aucune notification pour le moment.',
        zoom: 'Zoom',
        zoomLevel: 'Niveau de zoom',
        zoomIn: 'Zoom avant',
        zoomOut: 'Zoom arrière',
        zoomPercent: 'Zoom {percent}%',
        shapes: 'Formes',
        objects3d: 'Objets 3D',
        characters: 'Personnages',
        characterPresets: {
            humanoid: 'Humain',
            animal: 'Animal',
            turtle: 'Tortue',
            octopus: 'Pieuvre',
        },
        sceneEffects: 'Effets de scène',
        sceneEffectsLabel: 'Effets de scène',
        activeEffects: '{count} effets actifs',
        clearAllEffects: 'Effacer tous les effets',
        tools: {
            select: 'Sélection (V)',
            pan: 'Main (H, maintenir Espace)',
            line: 'Ligne (L)',
            curve: 'Courbe (P)',
            text: 'Texte (T)',
            rectangle: 'Rectangle (R)',
            circle: 'Cercle (C)',
            triangle: 'Triangle',
            polygon: 'Polygone (G)',
            cube3d: 'Cube 3D',
            sphere3d: 'Sphère 3D',
            box3d: 'Boîte 3D',
            cylinder3d: 'Cylindre 3D',
            prism3d: 'Prisme 3D',
            mesh3d: 'Maillage 3D',
            fog: 'Brouillard',
            rain: 'Pluie',
            snow: 'Neige',
            lightning: 'Éclair',
            particles: 'Particules',
            vignette: 'Vignette',
        },
    },
    movieSelector: {
        newMovie: 'Nouveau film',
        createNewMovie: 'Créer un nouveau film',
        movieNamePlaceholder: 'nom du film...',
        movieDescriptionPlaceholder: 'description du film...',
        recent: 'Récents',
        myProjects: 'Mes projets',
        sampleMovies: 'Films exemples',
        currentMovie: 'Film actuel',
        unloadMovie: 'Fermer le film',
        closeMovie: 'Fermer le film',
        deleteMovie: 'Supprimer le film',
        moreActions: "Plus d'actions",
        selectToPreview: 'Sélectionnez un film pour l’aperçu',
        deleteConfirmTitle: 'Supprimer le film ?',
        deleteConfirmDescription: '« {name} » sera définitivement supprimé.',
        thisMovie: 'Ce film',
        movieAria: 'film',
        today: "Aujourd'hui",
        yesterday: 'Hier',
        daysAgo: 'Il y a {count} jours',
        older: 'Plus ancien',
        errors: {
            idUnresolved: "L'identifiant du film n'a pas pu être résolu.",
            nameEmpty: 'Le nom du film ne peut pas être vide.',
            saveFailed: "Échec de l'enregistrement du film. Veuillez réessayer.",
        },
    },
    userMenu: {
        ariaLabel: 'Menu utilisateur',
        sectionsAria: 'Sections du menu utilisateur',
        tabs: {
            credits: 'Crédits',
            account: 'Compte',
            preferences: 'Préférences',
        },
        administration: 'Administration',
        signOut: 'Se déconnecter',
        loadingCredits: 'Chargement des crédits',
        creditsCount: '{count} crédits',
        credits: {
            currentBalance: 'Solde actuel',
            unit: 'crédits',
            add: 'Ajouter des crédits',
            hideAdd: "Masquer l'ajout de crédits",
            hideAddOptions: "Masquer les options d'ajout de crédits",
            loadingPurchase: "Chargement des options d'achat...",
            noCardOptions: 'Aucune option de paiement par carte configurée.',
            planCredits: '{count} crédits',
            loadWithTether: 'Recharger avec Tether (USDT)',
            loadingDeposit: 'Chargement...',
            noUsdtWallet: 'Aucune adresse de portefeuille USDT configurée.',
            rate: '1 {symbol} = {credits} crédits',
            copyAddress: "Copier l'adresse",
            recentTransactions: 'Transactions récentes',
            loadingTransactions: 'Chargement des transactions...',
            noTransactions: 'Aucune transaction pour le moment.',
        },
        account: {
            creditUsage: 'Utilisation des crédits',
            balance: 'Solde',
            earned: 'Gagnés',
            spent: 'Dépensés',
            transactions: 'Transactions',
            changePassword: 'Changer le mot de passe',
            changePasswordTitle: 'Changer le mot de passe',
            currentPassword: 'Mot de passe actuel',
            currentPasswordHint: 'Laisser vide pour les comptes sociaux uniquement',
            newPassword: 'Nouveau mot de passe',
            confirmPassword: 'Confirmer le nouveau mot de passe',
            updatePassword: 'Mettre à jour le mot de passe',
            saving: 'Enregistrement…',
            errors: {
                newRequired: 'Le nouveau mot de passe est requis.',
                minLength: 'Le nouveau mot de passe doit contenir au moins 6 caractères.',
                mismatch: 'Le nouveau mot de passe et la confirmation ne correspondent pas.',
                failed: 'Échec du changement de mot de passe.',
            },
            success: 'Mot de passe modifié avec succès.',
        },
    },
    sidebar: {
        collapse: 'Réduire le panneau',
        expand: 'Développer le panneau',
    },
    toolpads: {
        library: {
            title: 'Bibliothèque',
            dropImages: 'Déposez des images ici',
            importFiles: 'Importer des fichiers',
            import: '+ Importer',
            importAria: 'Importer des fichiers',
            uploading: 'Téléversement…',
            deleteConfirmTitle: 'Supprimer l’élément de bibliothèque ?',
            deleteConfirmDescription: '« {name} » sera définitivement supprimé.',
            deleteFailedTitle: 'Suppression impossible',
            deleteFailedFallback: 'Suppression impossible.',
            inUseTitle: 'Élément utilisé',
            inUseDescription: '« {name} » est utilisé par au moins un objet de scène ({count}). Retirez-le d’abord de la scène.',
            noLayerTitle: 'Aucun calque sélectionné',
            noLayerDescription: 'Sélectionnez un calque avant d’ajouter un objet de scène.',
            mine: 'Projet',
            vectorHint: 'Glissez sur la scène ou double-cliquez pour copier dans ce projet.',
            vectorsEmpty: 'La bibliothèque publique est vide.',
            vectorsLoadFailed: 'Impossible de charger la bibliothèque publique.',
            vectorUseFailed: 'Impossible d’ajouter cet élément au projet.',
        },
        scenes: {
            title: 'Scènes',
            empty: 'Aucune scène pour le moment.',
            add: '+ Ajouter une scène',
            defaultName: 'Scène {count}',
            nameAria: 'Nom de la scène',
            dragReorder: 'Glisser pour réordonner',
            deleteTitle: 'Supprimer la scène',
            deleteDescription: '« {name} » sera supprimée.',
            deleteTooltip: 'Supprimer la scène',
            cannotDeleteTitle: 'Impossible de supprimer la scène',
            cannotDeleteLast: 'Un film doit conserver au moins une scène. La dernière scène ne peut pas être supprimée.',
            createFailed: 'Impossible de créer la scène : {error}',
            deleteFailed: 'Impossible de supprimer la scène : {error}',
        },
        sceneObjects: {
            title: 'Objets de scène',
            empty: 'Ajoutez des objets à la scène en les faisant glisser depuis la bibliothèque.',
            selectAll: 'Tout sélectionner',
            selectAllAria: 'Sélectionner tous les objets de scène',
            selectedCount: '{count} sélectionnés',
            expand: 'Développer',
            collapse: 'Réduire',
            objectNameAria: 'Nom de l’objet',
            selectObject: 'Sélectionner {name}',
            selectObjectAndChildren: 'Sélectionner {name} et ses enfants',
            deselectObjectAndChildren: 'Désélectionner {name} et ses enfants',
            selectAllChildren: 'Sélectionner tous les enfants',
            all: 'Tous',
        },
        sceneEffects: {
            title: 'Effets de scène',
            empty: 'Activez des effets de scène depuis la barre d’outils pour régler leurs paramètres ici.',
            activeCount: '{count} actifs',
            clearAll: 'Tout effacer',
            expand: 'Développer les paramètres',
            collapse: 'Réduire les paramètres',
            enable: 'Activer l’effet',
            disable: 'Désactiver l’effet',
            params: {
                intensity: 'Intensité',
                speed: 'Vitesse',
                particleSize: 'Taille des particules',
                color: 'Couleur',
            },
        },
        clipFolders: {
            title: 'Dossiers de clips',
            empty: 'Aucun dossier de clips.',
            add: '+ Ajouter un dossier',
            defaultName: 'Dossier {count}',
            deleteTooltip: 'Supprimer le dossier',
        },
        movieProperties: {
            title: 'Propriétés du film',
            stageSize: 'Taille de la scène',
            width: 'L',
            height: 'H',
            frameRate: 'Fréquence d’images',
            frameRateAria: 'Fréquence d’images',
            fpsOption: '{count} FPS',
            info: 'Infos',
            name: 'Nom : ',
            scenes: 'Scènes : ',
            noMovie: 'Aucun film chargé.',
            publish: 'Publier',
            publishing: 'Publication…',
            publishHint: 'Crée un instantané en lecture seule pour le lecteur public.',
            linkCopied: 'Lien du lecteur copié.',
        },
    },
    rightSidebar: {
        style: {
            title: 'Style',
            selectObject: 'Sélectionnez un objet sur la scène pour ajuster les couleurs.',
            shapeOrTextOnly: 'Les réglages de style s’appliquent aux formes, textes et images.',
            text: 'Texte',
            textColor: 'Couleur du texte',
            fontSize: 'Taille de police',
            fontSizeAria: 'Taille de police',
            fontSizePxAria: 'Taille de police px',
            align: 'Aligner',
            textAlignAria: 'Alignement du texte',
            left: 'Gauche',
            center: 'Centre',
            right: 'Droite',
            justify: 'Justifier',
            colors: 'Couleurs',
            fill: 'Remplissage',
            fillModeAria: 'Mode de remplissage',
            fillSolid: 'Couleur',
            fillGradient: 'Dégradé',
            fillColor: 'Couleur de remplissage',
            gradientStart: 'Début',
            gradientEnd: 'Fin',
            gradientAngle: 'Angle',
            gradientAngleAria: 'Angle du dégradé',
            border: 'Bordure',
            borderTypeAria: 'Type de bordure',
            borderColor: 'Couleur de bordure',
            borderSizeAria: 'Taille de bordure',
            size: 'Taille',
            sides: 'Côtés',
            sidesAria: 'Côtés de la bordure',
            sideTop: 'Haut',
            sideRight: 'Droite',
            sideBottom: 'Bas',
            sideLeft: 'Gauche',
            solid: 'Plein',
            dashed: 'Tirets',
            dotted: 'Pointillés',
            fillBorderConflict: 'Le remplissage et la bordure ne peuvent pas être tous deux absents.',
            effects: 'Effets',
            shadow: 'Ombre',
            shadowColor: 'Couleur d’ombre',
            shadowOffsetX: 'Décalage X',
            shadowOffsetY: 'Décalage Y',
            shadowBlur: 'Flou',
            shadowSpread: 'Étendue',
            glow: 'Lueur',
            glowColor: 'Couleur de lueur',
            glowBlur: 'Flou de lueur',
            enabled: 'Oui',
            disabled: 'Non',
        },
        properties: {
            title: 'Propriétés',
            object: 'Objet',
            tween: 'Tween',
            transform: 'Transformation',
            stageTools: 'Outils de scène',
            stageResize: 'Resize',
            stageRotate: 'Rotate',
            stageResizeHint: 'Afficher les poignées de redimensionnement sur l’objet sélectionné',
            stageRotateHint: 'Afficher les poignées de rotation aux coins et le pivot',
            pivotHint: 'Glisser pour définir le pivot / articulation',
            keepAspectRatio: 'Conserver les proportions',
            keepAspectRatioHint: 'Aussi activé temporairement en redimensionnant avec Shift.',
            appearance: 'Apparence',
            rotation: 'Rotation',
            rotationAria: 'Rotation',
            rotationDegreesAria: 'Degrés de rotation',
            opacity: 'Opacité',
            opacityAria: 'Opacité',
            opacityPercentAria: 'Pourcentage d’opacité',
            visibility: 'Visibilité',
            activeTween: 'Tween actif ({start} → {end})',
            easing: 'Easing',
            easingAria: 'Type d’easing',
            linear: 'Linear',
            easeIn: 'Ease In',
            easeOut: 'Ease Out',
            easeInOut: 'Ease In-Out',
            bounce: 'Bounce',
            elastic: 'Elastic',
            back: 'Back',
            noTween: 'Aucun tween sur l’image actuelle.',
            noTweenHint: 'Créez deux keyframes et ajoutez un tween entre elles.',
            allTweens: 'Tous les tweens',
            frameRange: 'Image {start} → {end}',
            noSelection: 'Sélectionnez quelque chose sur la scène ou la timeline pour voir et modifier ses propriétés.',
            selectedObjects: '{count} objets sélectionnés',
            selectedObjectAria: 'Objet à modifier dans la sélection',
            keyframe: 'Keyframe',
            frame: 'Image :',
            activeKeyframe: '◆ Keyframe active : Image {frame}',
            noKeyframe: 'Aucune keyframe à ou avant l’image actuelle',
            selectFrameHint: 'Sélectionnez une image sur la timeline',
            createKeyframe: 'Créer une keyframe',
            updateKeyframe: 'Mettre à jour la keyframe',
            stateObjects: 'Objets portant un state',
            noStateObjects: 'Cette keyframe ne porte aucun state d’objet.',
            copyStateToPrevious: 'Copier le state vers la keyframe précédente ({frame})',
            copyStateToNext: 'Copier le state vers la keyframe suivante ({frame})',
            noPreviousKeyframe: 'Aucune keyframe précédente',
            noNextKeyframe: 'Aucune keyframe suivante',
        },
        align: {
            title: 'Aligner',
            horizontal: 'Horizontal',
            vertical: 'Vertical',
            left: 'Aligner à gauche',
            center: 'Centrer',
            right: 'Aligner à droite',
            top: 'Aligner en haut',
            middle: 'Aligner au milieu',
            bottom: 'Aligner en bas',
        },
    },
    timeline: {
        prevFrame: 'Image précédente (,)',
        pause: 'Pause (Space)',
        play: 'Lecture (Space)',
        playNeedsKeyframe: 'Au moins une keyframe est requise pour lire',
        stop: 'Arrêt (.)',
        nextFrame: 'Image suivante (.)',
        addKeyframe: 'Ajouter une keyframe (F6)',
        deselectKeyframe: 'Désélectionnez la keyframe pour ajouter à la tête de lecture',
        keyframeExists: 'Une keyframe existe déjà sur l’image actuelle',
        deleteKeyframe: 'Supprimer la keyframe',
        addTween: 'Ajouter un tween (F7)',
        addTweenHint: 'Peut être ajouté entre deux keyframes lorsqu’il n’y a pas de tween',
        deleteTween: 'Supprimer le tween',
        frame: 'Image :',
        time: 'Temps :',
        total: 'Total :',
        totalFramesAria: 'Images totales',
        addLayer: 'Ajouter un calque',
        newLayer: 'Nouveau calque',
        dragReorder: 'Glisser pour réordonner',
        deleteLayer: 'Supprimer le calque',
        cannotDeleteTitle: 'Impossible de supprimer le calque',
        cannotDeleteLast: 'Une scène doit conserver au moins un calque. Le dernier ne peut pas être supprimé.',
        cannotDeleteNonEmpty: 'Ce calque n’est pas vide. Effacez ses keyframes, tweens et objets de scène avant de le supprimer.',
        tweenTitle: 'Tween : {start} - {end} ({easing})',
        frameTitle: 'Image {frame}',
        frameDeleting: 'Image {frame} (suppression...)',
        addKeyframeAt: 'Ajouter une keyframe (Image {frame})',
        addTweenShort: 'Ajouter un tween',
        clearAllKeyframes: 'Effacer toutes les keyframes',
        clearAllTweens: 'Effacer tous les tweens',
    },
    stage: {
        selectionToolbar: 'Actions de l’objet',
        duplicate: 'Dupliquer',
        createGroup: 'Créer un groupe',
        createPattern: 'Créer un motif',
        ungroup: 'Dégrouper',
        removeFromGroup: 'Retirer du groupe',
        groupName: 'Groupe',
        insideThisLayer: 'Dans ce calque',
        bringToFront: 'Mettre au premier plan',
        bringForward: 'Avancer',
        sendBackward: 'Reculer',
        sendToBack: 'Mettre à l’arrière-plan',
        sendToLayer: 'Envoyer au calque',
        sendInto: 'Envoyer dans',
        noSendIntoTargets: 'Aucun objet sur ce calque',
        objectFallback: 'Objet {id}',
        noLayers: 'Aucun calque',
        layerFallback: 'Calque {id}',
        noLayerTitle: 'Aucun calque sélectionné',
        noLayerDescription: 'Pour ajouter un objet de scène, sélectionnez d’abord un calque.',
    },
    welcome: {
        title: 'Bienvenue',
        subtitle: 'Vous pouvez créer un nouveau projet ou en sélectionner un récemment utilisé.',
        createProject: 'Créer un nouveau projet',
        projectNamePlaceholder: 'Nom du projet...',
        recentlyUsed: 'Récemment utilisés',
        noRecent: 'Aucun projet récemment utilisé',
        myProjects: 'Mes projets',
        sampleProjects: 'Projets exemples',
        empty: 'Aucun projet pour le moment. Commencez par en créer un !',
        movieAria: 'film',
        previewTitle: 'Aperçu',
        openProject: 'Ouvrir le projet',
        noDescription: 'Aucune description',
        resolution: 'Résolution',
        fps: 'Fréquence d’images',
        fpsValue: '{fps} fps',
        scenes: 'Scènes',
        sceneObjects: 'Objets de scène',
        layers: 'Calques',
        sampleBadge: 'Exemple',
    },
    aiChat: {
        deleteMessage: 'Supprimer le message',
        thinking: 'Réflexion...',
        jobs: 'Tâches',
        actions: 'Actions',
        payloads: 'Payloads',
        executionResults: 'Résultats d’exécution',
        loading: 'Chargement...',
        resizePanel: 'Redimensionner le panneau de chat',
        selectConversation: 'Sélectionner une conversation',
        newChat: 'Nouveau chat',
        newChatTooltip: 'Nouveau chat',
        deleteConversation: 'Supprimer la conversation',
        debugOn: 'Mode debug activé',
        debugOff: 'Mode debug désactivé',
        placeholder: 'Décrivez une scène ...',
        send: 'Envoyer',
    },
    admin: {
        badge: 'Admin',
        backToEditor: "Retour à l'éditeur",
        topbarTitle: 'Admin',
        a11y: {
            closeNav: 'Fermer la navigation',
            openNav: 'Ouvrir la navigation',
        },
        nav: {
            dashboard: 'Tableau de bord',
            users: 'Utilisateurs',
            projects: 'Projets',
            activity: 'Activité',
            activityDesc: 'SignalR · journal',
            activityTitle: "Connexions SignalR en direct et journal d'activité",
            storageProviders: 'Fournisseurs de stockage',
            socialProviders: 'Social Login',
            ai: 'IA',
            providers: 'Fournisseurs',
            prompts: 'Prompts',
            payment: 'Paiement',
            cryptoWallets: 'Portefeuilles crypto',
            disclaimers: 'Mentions légales',
            install: 'Installation',
            analytics: 'Analytique',
            settings: 'Paramètres',
            vectorPackages: 'Bibliothèque publique',
        },
        vectorPackages: {
            title: 'Bibliothèque publique',
            description: 'Bibliothèque de la plateforme, partagée avec chaque projet. Importez un dépôt git ou téléversez un zip. Chaque dossier devient un paquet.',
            name: 'Nom du paquet',
            file: 'Fichier du paquet',
            fileHint: 'Zip, SVG, PNG, WebP ou JPEG. Un zip est décompressé fichier par fichier.',
            upload: 'Téléverser le paquet',
            uploading: 'Téléversement…',
            empty: 'La bibliothèque publique est vide.',
            files: '{count} fichiers',
            delete: 'Supprimer',
            preview: 'Fichiers',
            hide: 'Masquer',
            deleteConfirm: 'Supprimer « {name} » et ses fichiers ?',
            uploadFailed: 'Téléversement échoué.',
            deleteFailed: 'Impossible de supprimer le paquet.',
            nameRequired: 'Le nom du paquet est requis.',
            fileRequired: 'Choisissez un fichier de paquet.',
            loadFailed: 'Impossible de charger la bibliothèque publique.',
            gitUrl: 'URL du dépôt',
            gitBranch: 'Branche',
            gitPath: 'Dossier',
            gitFormat: 'Format',
            formatSvg: 'SVG',
            formatPng: 'PNG',
            gitHint: 'HTTPS seulement. Un dossier comme kits crée un paquet par sous-dossier. SVG et PNG ne sont pas importés ensemble. Un nouvel import met à jour les mêmes paquets.',
            gitImport: 'Importer le dépôt',
            gitImporting: 'Importation…',
            gitImported: '{count} paquets importés.',
            gitFailed: 'Le dépôt n’a pas pu être importé.',
            gitUrlRequired: 'L’URL du dépôt est requise.',
        },
    },
};
